import { AxiosError } from 'axios';
import { getAuthToken, baseRequest } from '../services';
import { useToast } from './useToast';
import { useUIContext } from './useUIContext';

export interface IRequestOptions {
  hidePreloader?: boolean;
  hideErrorMessage?: boolean;
}

export interface IRequest {
  method: 'post' | 'get' | 'put' | 'delete';
  url: string;
  data?: object | null;
  headers?: object;
}

export const useRequest = () => {
  const { show, hide } = useUIContext();
  const { showToast } = useToast();

  const onErrorHandling = ({ error, hideErrorMessage }: { error: AxiosError; hideErrorMessage?: boolean }) => {
    if (hideErrorMessage) {
      return Promise.reject(error?.response || error);
    } else {
      const errStatus = error?.response?.status;

      if (!errStatus || (errStatus !== 401 && errStatus !== 400)) {
        // 401 - unauthorized
        // 400 - form data invalid
        showToast({ type: 'error', message: error?.message });
      }
      return Promise.reject(error.response || error);
    }
  };

  const request = async (settings: IRequest, options?: IRequestOptions) => {
    const { hidePreloader, hideErrorMessage } = options || {};
    if (!hidePreloader) {
      show();
    }

    try {
      const res = await baseRequest(settings);
      return res;
    } catch (err) {
      const error = err as AxiosError<Error>;
      return onErrorHandling({ error, hideErrorMessage });
    } finally {
      hide();
    }
  };

  const authRequest = (settings: IRequest, options?: IRequestOptions) => {
    const token = getAuthToken();
    settings.headers = { ...settings.headers, Authorization: token };
    return request(settings, options);
  };

  return { request, authRequest };
};
